import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, Cloud, ShieldCheck, Database, Cpu, Users } from "lucide-react";
import HeroBackground from "@/components/HeroBackground";
import FinalCTA from "@/components/FinalCTA";
import SectionHeading from "@/components/SectionHeading";
import { useT } from "@/i18n";

const ICONS = {
  "ai-transformation": Sparkles,
  "dedicated-teams": Users,
  cloud: Cloud,
  cybersecurity: ShieldCheck,
  sap: Database,
  "software-engineering": Cpu,
};

export default function Services() {
  const t = useT();
  return (
    <div>
      <section className="relative overflow-hidden">
        <HeroBackground />
        <div className="relative nx-container pt-16 md:pt-24 pb-20 md:pb-28">
          <div className="nx-mono text-xs uppercase tracking-[0.32em] text-[#38D8FF] mb-5 nx-fade-in">
            / {t.servicesPage.eyebrow}
          </div>
          <h1 className="nx-heading text-5xl sm:text-6xl lg:text-7xl font-bold leading-tight max-w-4xl tracking-tight nx-fade-in">
            <span className="nx-gradient-text">{t.servicesPage.title1}</span> {t.servicesPage.title2}
          </h1>
          <p className="mt-6 max-w-2xl text-lg text-white/75 leading-relaxed nx-fade-in">
            {t.servicesPage.lede}
          </p>
        </div>
      </section>

      <section className="nx-container pb-24 md:pb-32 space-y-5">
        {t.services.map((s, i) => {
          const Icon = ICONS[s.slug] || Sparkles;
          return (
            <div
              key={s.slug}
              className="nx-card rounded-2xl p-8 md:p-10 grid grid-cols-1 md:grid-cols-12 gap-8 items-start"
            >
              <div className="md:col-span-1">
                <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-[#0057FF]/40 to-[#38D8FF]/20 border border-white/10 flex items-center justify-center">
                  <Icon className="w-5 h-5 text-[#38D8FF]" />
                </div>
              </div>
              <div className="md:col-span-6">
                <div className="nx-mono text-xs text-white/40 mb-2">/ 0{i + 1}</div>
                <h3 className="nx-heading text-2xl md:text-3xl font-semibold">{s.title}</h3>
                <p className="mt-4 text-white/70 leading-relaxed">{s.summary}</p>
              </div>
              <div className="md:col-span-5">
                <div className="grid grid-cols-2 gap-2">
                  {s.bullets.map((b) => (
                    <div key={b} className="px-3 py-2 rounded-md border border-white/10 bg-white/[0.02] text-xs text-white/80">
                      {b}
                    </div>
                  ))}
                </div>
                <Link
                  to={s.slug === "ai-transformation" ? "/ai-transformation" : "/contact"}
                  className="mt-6 inline-flex items-center gap-2 text-sm text-[#38D8FF] hover:text-white transition"
                >
                  {t.servicesPage.talkLink} <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </div>
          );
        })}
      </section>

      <FinalCTA />
    </div>
  );
}
